import React from "react";
import { string, func, any, array, bool, number } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import { SearchBox } from "@quintype/components";
import SearchIcon from "../icons/search-icon/index";

import { setRecentSearch } from "../../helper/actions";
import { wruUserEvent } from "../../helper/api";
import { readCookie } from "../../helper/cookies";

import "./search-input.m.css";

const DrawForm = ({ children }) => (
  <div styleName="search-input">
    <label htmlFor="searchForm">{children}</label>
    <button type="submit" styleName="search">
      Search
    </button>
  </div>
);

const DrawFormIcon = ({ children }) => (
  <div styleName="search-input-icon">
    <label htmlFor="searchForm">{children}</label>
    <button type="submit" styleName="search-icon">
      <SearchIcon height={26} width={26} />
    </button>
  </div>
);

DrawForm.propTypes = {
  children: any,
};

DrawFormIcon.propTypes = {
  children: any,
};

const SearchInput = ({ inputId, isSearchIcon, defaultValue, closeClick, list, setRecentSearch, merchantId }) => {
  const onSubmitClick = (text) => {
    if (text) {
      // If the top item and searched text is same then don't save as it same
      if (list[0] !== text) {
        const newList = [text, ...list];
        setRecentSearch(newList.slice(0, 5)); // Update Store

        const body = {
          uid: readCookie("thinmint"),
          merchantId: `${merchantId}`,
          Ref: "user search",
          timestamp: `${new Date().getTime()}`,
          eventType: "SEARCH_EVENT",
          payload: {
            search_text: text,
          },
        };
        wruUserEvent(merchantId, body).then((i) => console.log("Search Event", i));
      }
    }

    if (closeClick) {
      document.getElementById(inputId).value = "";
      closeClick();
    }
  };

  return (
    <div styleName="wrapper" className="search-wrapper">
      <SearchBox
        placeholder="Search"
        styleName="search-box"
        inputId={inputId}
        inputClassName="search__form-input"
        template={isSearchIcon ? DrawFormIcon : DrawForm}
        initValue={defaultValue}
        onSubmitHandler={onSubmitClick}
      />
    </div>
  );
};

SearchInput.defaultProps = {
  inputId: "searchForm",
  isSearchIcon: false,
};

SearchInput.propTypes = {
  defaultValue: string,
  inputId: string,
  closeClick: func,
  list: array,
  setRecentSearch: func,
  isSearchIcon: bool,
  merchantId: number,
};

const mapStateToProps = (state) => ({
  list: get(state, ["settingsReducer", "recentSearchList"], []),
  merchantId: get(state, ["qt", "config", "publisher-attributes", "wru_id"]),
});

const mapDispatchToProps = (dispatch) => ({
  setRecentSearch: (list) => dispatch(setRecentSearch(list)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchInput);
